import React, { createContext, useContext } from 'react'

import { GridContainerProps } from './GridContainer.types'

const GridContainerContext = createContext(null)

export const useGridContainerContext = () => {
    return useContext(GridContainerContext)
}

const GridContainer: React.FC<GridContainerProps> = ({ children }) => {
    const spacing = 12
    const ctx = {
        spacing,
    }

    return (
        <GridContainerContext.Provider value={ctx}>
            <div
                style={{
                    height: '100%',
                    padding: `${spacing / 2}px`,
                }}
                data-testid='GridContainer'
                className='r-gridcontainer-container'
            >
                {children}
            </div>
        </GridContainerContext.Provider>
    )
}

export default GridContainer
